export default "__VITE_ASSET__7b572fa3__"